import React from 'react';
import { useAppSelector } from 'src/hooks';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  LinearProgress
} from '@mui/material';
import ReactMarkdown from 'react-markdown';

export default function DataMaturity() {
  const { isMarketMaturityDataLoading, marketMaturityCardsData } =
    useAppSelector((state) => state.landing);

  // Extracting visible cards from API response
  const visibleCards =
    marketMaturityCardsData?.market_maturity_details?.market_maturity_table
      ?.length > 0
      ? marketMaturityCardsData.market_maturity_details.market_maturity_table.filter(
          (item) => item.is_visible
        )
      : [];

  return (
    <Grid
      container
      sx={{
        width: '100%',
        marginTop: '5px',
        minHeight: '300px',
        maxHeight: '350px',
        overflowY: 'auto',
        padding: '12px',
        margin: 'auto'
      }}
    >
      {isMarketMaturityDataLoading ? (
        <div style={{ padding: '10px 0px' }}>
          <LinearProgress />
        </div>
      ) : marketMaturityCardsData?.market_maturity_details
          ?.market_maturity_table?.length > 0 ? (
        visibleCards.length > 0 ? (
          visibleCards.map((card, index) => (
            <Grid item key={index} sm={12 / visibleCards.length}>
              <Card
                sx={{
                  display: 'inline-flex',
                  minWidth: '100px',
                  maxWidth: '400px',
                  padding: '2px',
                  backgroundColor: '#F8F9FC'
                }}
              >
                <CardContent
                  sx={{
                    padding: '5px 0px 5px 24px',
                    width: '190px',
                    height: '150px'
                  }}
                >
                  <span
                    style={{
                      color: '#3A3A3A',
                      fontSize: '14px',
                      fontWeight: '400',
                      lineHeight: '20px',
                      fontFamily:
                        'MarsCentra,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol",system-ui'
                    }}
                  >
                    {card.alias}
                  </span>
                  {/* Render the description using ReactMarkdown if datatype is MARKDOWN */}
                  <Typography
                    sx={{
                      fontSize: '12px',
                      color: '#3A3A3A',
                      fontFamily:
                        'MarsCentra,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol",system-ui'
                    }}
                  >
                    {card.datatype === 'MARKDOWN' ? (
                      <ReactMarkdown>{card.description}</ReactMarkdown>
                    ) : (
                      card.description
                    )}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <div>No visible data available</div>
        )
      ) : (
        <div>No data found</div>
      )}
    </Grid>
  );
}
